require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-introducing-pint-the-new-build-system-for-grunt-js.json") })
        }
      }, "path---blog-introducing-pint-the-new-build-system-for-grunt-js");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-introducing-pint-the-new-build-system-for-grunt-js!./.cache/json/blog-introducing-pint-the-new-build-system-for-grunt-js.json
// module id = 898
// module chunks = 231608221292675